<template>
  <div id="app-main">
    <router-view></router-view>
  </div>
</template>

<script>
import { toggleBodyTheme } from "@/utils";

export default {
  created() {
    toggleBodyTheme(this.$store.state.theme);
  }
};
</script>

<style lang="scss"></style>
